<template>
<div>
  <!--Dialog para confirmação de exclusão-->
  <p-confirm text="Tem certeza que deseja excluir esse gráfico" :dialog="dialogConfirm" @confirm="changeItem('del')" @cancel="dialogConfirm = false"></p-confirm>
  <!-- Dialog para mostrar as opções de data para o usuário selecionar a que ele quiser -->
  <v-dialog v-model="dialogDateOptions" persistent scrollable width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Período
      </v-card-title>
      <v-card-text>
        <v-form >
          <v-container grid-list-md>
            <v-layout wrap justify-left align-center>
              <v-flex>
                <h4>{{this.dateField['text']}}</h4>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select v-model="dateField['date_type']" :items="translate('value.dashboard_date_type')" label="Tipo" required></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-1" color="primary darken-1" :disabled="dateField['date_type'] === ''" @click="changeFieldDate()">Aplicar</v-btn>
        <v-btn class="mx-1" @click="closeFieldDate()">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Dialog para gerenciar os filtros de cada card -->
  <v-dialog v-model="dialogFilters" persistent scrollable width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Filtros
      </v-card-title>
      <v-card-text>
        <v-form >
          <v-container grid-list-md>
            <v-layout wrap justify-left align-center>
              <v-flex>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select multiple v-model="editedItem['filters']['status']" :items="statusItems" label="Status" required></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select v-model="editedItem['filters']['end_status']" :items="translate('value.dashboard_date_status')" label="Status da Previsão" required></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-1" color="primary darken-1" @click="processSave()">Aplicar</v-btn>
        <v-btn class="mx-1" @click="closeFilters()">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Dialog para criar um novo card -->
  <v-dialog v-model="dialogCreate" max-width="600px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title primary-title>
        <span class="headline">Inclusão de gráfico</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="padding: 0px">
        <v-form @keyup.native.esc="closeDialogCreate()" @keyup.native.ctrl.enter="processSave()" id="form" ref="form">
          <v-container grid-list-md>
            <v-layout wrap justify-center align-center>
              <v-flex xs2 class="text-xs-center">
                <swatches id="card_color" v-model="editedItem['color']" colors="material-basic" row-length="4" shapes="circles" popover-to="right" :swatch-style="{ margin: '5px 5px' }" show-fallback></swatches>
              </v-flex>
              <v-flex xs10>
                <v-text-field id="card_id_text" maxlength="25" counter="25" ref="autofocus" v-model="editedItem['id_text']" :label="translate('table.dashboard_chart.field.id_text')" :rules="requiredRule(translate('table.dashboard_chart.field.id_text'))"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :no-data-text="translate('system.table.emptyTable')"
                  v-model="editedItem['card_type']"
                  @change="changeCardtype"
                  :items="translate('value.dashboard_card_type')"
                  :label="translate('table.dashboard_chart.field.card_type')"
                  :rules="requiredRule(translate('table.dashboard_chart.field.card_type'))"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete v-if="editedItem['card_type'] !== 1" validate-on-blur v-model="editedItem['grouping_fields']" :items="fieldItems" return-object @change="changeGroupingFields" no-data-text="Selecione os campos para agrupá-los" label="Legenda" :rules="requiredRule('Legenda')" :loading="loadingFields">
                  <template v-slot:selection="data">
                    <div style="height: 35px;position: relative; padding-right: 10px; padding-top: 5px;">
                      <span>{{ data.item['text'] }}
                        <span v-if="data.item['date_type']" style="color: gray;font-size: 11px; ">{{ ' (' + translate('value.dashboard_date_type').find((val) => val['value'] === data.item['date_type'])['text'] + ')' }}</span>
                      </span>
                      <span style="position: absolute; bottom: 0px; left: 0px; color: gray;font-size: 10px; ">{{getFieldItem(data.item)}}</span>
                    </div>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="data['type'] === 'custom'">
                      <v-list-tile-content v-text="data['item']"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-action v-if="editedItem['card_type'] === 1">
                        <v-checkbox :input-value="data.tile.props.value"></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ data.item['text'] }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ getFieldItem(data.item, 75) }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete :multiple="editedItem['card_type'] === 1" validate-on-blur v-model="editedItem['fields']" :items="fieldItems" :label="editedItem['card_type'] === 1 ? 'Campos' : 'Valor'" return-object :rules="editedItem['card_type'] === 1 ? requiredManyRule('Campos') : requiredRule('Valor')" @change="changeFields" :loading="loadingFields" :no-data-text="translate('system.table.emptyTable')">
                  <template v-slot:selection="data">
                    <div style="height: 35px;position: relative; padding-right: 10px; padding-top: 5px;">
                      <span>{{ data.item['text'] }}{{ editedItem['card_type'] === 1 && data.index !== (editedItem['fields'].length - 1) ? ', ' : ' ' }}</span>
                      <span style="position: absolute; bottom: 0px; left: 0px; color: gray;font-size: 10px; ">
                        {{getFieldItem(data.item)}}</span>
                    </div>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="data['type'] === 'custom'">
                      <v-list-tile-content v-text="data['item']"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-action v-if="editedItem['card_type'] === 1">
                        <v-checkbox :input-value="data.tile.props.value"></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ data.item['text'] }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ getFieldItem(data.item, 75) }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete v-if="editedItem['card_type'] === 1" multiple validate-on-blur v-model="editedItem['grouping_fields']" :items="editedItem['fields']" return-object @change="changeGroupingFields" :label="translate('table.dashboard_chart.field.grouping_fields')" :no-data-text="translate('system.table.emptyTable')">
                  <template v-slot:selection="data">
                    <div style="height: 35px;position: relative; padding-right: 10px; padding-top: 5px;">
                      <span>{{ data.item['text'] }}
                        <span v-if="data.item['date_type']" style="color: gray;font-size: 11px; ">{{ ' (' + translate('value.dashboard_date_type').find((val) => val['value'] === data.item['date_type'])['text'] + ')' }}</span>
                        {{ editedItem['card_type'] === 1 && data.index !== (editedItem['grouping_fields'].length - 1) ? ', ' : ' ' }}
                      </span>
                      <span style="position: absolute; bottom: 0px; left: 0px; color: gray;font-size: 10px; ">{{getFieldItem(data.item)}}</span>
                    </div>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="data['type'] === 'custom'">
                      <v-list-tile-content v-text="data['item']"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-action v-if="editedItem['card_type'] === 1">
                        <v-checkbox :input-value="data.tile.props.value"></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ data.item['text'] }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ getFieldItem(data.item, 75) }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="processSave()">Salvar</v-btn>
        <v-btn class="mx-0" :loading="loading" @click.native="closeDialogCreate()">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- <v-dialog :value="false" scrollable persistent> -->
  <!-- <v-btn @click="createItem()">Adicionar</v-btn>
  <v-divider></v-divider> -->
  <div style="background:#eee; position: relative">
    <div v-if="items.length > 0" style="height: 20px;">
      <v-tooltip left>
        <v-btn slot="activator" small outline round color="primary" @click="reloadCharts" :loading="loadingReload" style="position: absolute; top: 0; right: 0; z-index:1">
          <span style="position: absolute">Atualizar</span>
          <v-progress-linear height="4" :value="timeReload" style="position: absolute; margin-top: 30px;"></v-progress-linear>
        </v-btn>
        <span>A dashboard será atualizada a cada 5 minutos</span>
      </v-tooltip>
    </div>
    <grid-layout v-if="items.length > 0"
      :layout.sync="items"
      :col-num="12"
      :row-height="50"
      :is-draggable="checkPermission('dashboard_custom', 'manage') && !$vuetify.breakpoint.smAndDown"
      :is-resizable="checkPermission('dashboard_custom', 'manage') && !$vuetify.breakpoint.smAndDown"
      :is-mirrored="false"
      :vertical-compact="true"
      :margin="[20, 20]"
      :use-css-transforms="true">
      <grid-item v-for="(item) in items"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
        :minW="item['card_type'] === 1 ? 2 : 4"
        :minH="item['card_type'] === 1 ? 2 : 4"
        :key="item.i"
        @resized="changeItem()"
        @moved="changeItem()"
        class="elevation-5"
        >
        <!-- <span class="text">{{item.i}}</span> -->
        <!-- <span class="remove" @click="deleteItem(item.i)">x</span> -->
        <card-table v-if="item['card_type'] === 1" :ref="'chart' + item['i']" :cardValues="item" :dashboardId="dashboard['id']" @deleteItem="deleteItem" @editItem="editItem" @filtersItem="filtersItem"></card-table>
        <card-chart v-else-if="item['card_type'] >= 2" :ref="'chart' + item['i']" :cardValues="item" :dashboardId="dashboard['id']" @deleteItem="deleteItem" @editItem="editItem" @filtersItem="filtersItem"></card-chart>
      </grid-item>
    </grid-layout>
    <!-- // caso o usuário não tenha permissão ou esteja no mobile, não é possivel inserir graficos -->
    <v-tooltip v-if="$vuetify.breakpoint.smAndDown || !checkPermission('dashboard_custom', 'create')"  top>
      <v-btn slot="activator" outline block color="primary" disabled> <v-icon>addchart</v-icon>Adicionar Gráfico </v-btn>
      <span>{{$vuetify.breakpoint.smAndDown ? 'Não é possível adicionar gráficos pelo celular' : 'Sem permissão para adicionar gráficos'}}</span>
    </v-tooltip>
    <v-btn v-else outline block color="primary" @click="createItem()">
        <v-icon>addchart</v-icon>Adicionar Gráfico
    </v-btn>
  </div>
  <!-- </v-dialog> -->
</div>
</template>
<script>
  /* eslint-disable eqeqeq */
  import VueGridLayout from 'vue-grid-layout'
  import PConfirm from './../shared/PConfirm'
  import CardTable from './cards/CardTable'
  import CardChart from './cards/CardChart'
  import Swatches from 'vue-swatches'
  import rules from './../../mixin/rules'
  import access from './../../mixin/access'

  export default {
    mixins: [rules, access],
    components: {PConfirm, CardTable, CardChart, GridLayout: VueGridLayout.GridLayout, GridItem: VueGridLayout.GridItem, Swatches},
    data: () => ({
      entity: 'dashboards',
      dialogCreate: false,
      dialogFilters: false,
      loadingReload: false,
      loading: false,
      dialogConfirm: false,
      dialogDateOptions: false,
      intervalReload: null,
      timeReload: 100,
      loadingFields: false,
      // fieldsTemplate armazena os campos das tarefas modelo, para buscar os valores
      fieldsTemplate: false,
      // controla alguns momentos para abrir e fechar a lsita de campos
      toggleFieldSelect: false,
      // lengthSelectedFields server para armazenar o tamanho antigo pra saber se foi adicionado ou removido algum item
      beforeLengthSelectedFields: 0,
      editedItem: {x: 0, y: 0, w: 5, h: 5, i: 0, type: 1, card_type: 1, fields: [], grouping_fields: [], filters: {status: [], end_status: ''}, id_text: '', color: '#00acc2'},
      defaultEditedItem: {x: 0, y: 0, w: 5, h: 5, i: 0, type: 1, card_type: 1, fields: [], grouping_fields: [], filters: {status: [], end_status: ''}, id_text: '', color: '#00acc2'},
      dateField: {date_type: ''},
      items: [],
      // Usado o itemsBDMobile para fazer alterações nos graficos quando estiver no mobile. Pois com ela não reajusta os tamanhos e posições dos graficos
      itemsBDMobile: [],
      fieldItems: [],
      statusItems: [],
      dashboard: {id: '', task_board_id: '', id_text: ''}
    }),
    sockets: {
      socketReloadDashboard (values) {
        // caso o usuário esteja no mobile e tenha recebido o socket de um pc ou vice versa, pede ele para atualizar a pagina
        this.reloadDashboard()
        this.$store.commit('snackbar/change_values', { text: 'Houve alterações na estrutuda da dashboard!', color: 'warning', dialog: true })
      }
    },
    created () {
      this.$store.commit('loader/change_dialog', true)
      this.intervalReload = setInterval(() => {
        // tira 0,33 pois quando o timeReload da 0 significa que deu 15 m
        this.timeReload = this.timeReload - 0.33
        if (this.timeReload <= 0) {
          this.reloadCharts(false)
          this.loadingReload = true
          setTimeout(() => {
            this.loadingReload = false
          }, 10000)
        }
      }, 1000)
      this.reloadDashboard()
      // Verifica se na area de trabalho já pssio status filtrados, caso tenha busca eles, caso naõ tenha, busca do banco
      let properties = this.$store.getters[`selectedBoard/properties`]
      if (properties.hasOwnProperty('status') && properties['status'] != '' && properties['status'] != []) {
        this.statusItems = properties['status']
      } else {
        this.$http.get(`api/task_status`).then((res) => {
          this.statusItems = res.body.map((item) => { return item['id_text'] })
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os status.', color: 'error', dialog: true})
        })
      }
    },
    methods: {
      reloadDashboard () {
        // sai da sala caso esteja em uma, pode acontece quando troca de area de trabalho
        this.$socket.emit('leaveRoom', {room: 'dashboard_' + this.dashboard['id']})
        let selectedBoardId = this.$store.getters[`selectedBoard/id`]
        this.$http.get(`api/dashboards/${selectedBoardId}`).then((res) => {
          this.dashboard = res.body
          this.$socket.emit('joinRoom', {room: 'dashboard_' + this.dashboard['id']})
          this.itemsBDMobile = JSON.parse(res.body['id_text'])
          // Caso o formato seja mobile então preenche as posições de cada grafico para se adequar ao mobile
          this.items = []
          setTimeout(() => {
            if (this.$vuetify.breakpoint.smAndDown) {
              JSON.parse(res.body['id_text']).forEach((item, index) => {
                this.items.push(Object.assign(item, {x: 0, y: ((index * 4) + 1), w: 12, h: 4}))
              })
              // caso não seja mobile pega os itens com as posições normais
            } else {
              this.items = JSON.parse(res.body['id_text'])
            }
          }, 100)
          // if (this.items.length === 0) {
          //   this.items = [{x: 0, y: 0, w: 5, h: 5, i: 0, type: 0}]
          // }
          this.$store.commit('loader/change_dialog', false)
          this.dialogConfirm = false
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível acessar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
        })
      },
      reloadCharts (loading = true) {
        // Volta a atualização a 100
        this.timeReload = 100
        this.loadingReload = true
        this.items.forEach(item => {
          let ref = 'chart' + item['i']
          this.$refs[ref][0].reloadItems(loading)
        })
        // define um tempo padrão de 20 segundos para que tudos seja atualizado e o usuário possa clicar novamente para atualizar
        setTimeout(() => {
          this.loadingReload = false
        }, 15000)
      },
      changeFields (items) {
        // Caso seja grafico de tabela, ao modificar os campos, zera os agrupamentos
        if (this.editedItem['card_type'] === 1) {
          this.editedItem['grouping_fields'] = []
          this.beforeLengthSelectedFields = 0
        }
      },
      changeGroupingFields (items) {
        let item = null
        // verifica se não é array pois se não for os itens são de colunas ou pizzas etc e se for é da tabela que pode ter mais de um valor
        // verifica se tem algum item e se a quantidade de antes é maior do que a atual, pois se sim significa que o usuário clicou para adicionar um novo item
        if (items && (!Array.isArray(items) || (items.length > 0 && this.beforeLengthSelectedFields < items.length))) {
          item = Array.isArray(items) ? items[items.length - 1] : items
          // verifica se o tipo do item adicionardo é date para abrir a telinha pro usuário escolher o tipo de data
          if (item['type'] === 'date' || item['type'] === 'datetime') {
            Object.assign(this.dateField, {date_type: 'datetime'}, item)
            this.dialogDateOptions = true
            this.toggleFieldSelect = false
          }
        }
        this.beforeLengthSelectedFields = Array.isArray(items) ? items.length : 0
      },
      changeFieldDate () {
        // pega o ultimo item selecionado que deveria ser a data, e insere os valores do type e status
        let dateItem = Array.isArray(this.editedItem['grouping_fields']) ? this.editedItem['grouping_fields'][this.editedItem['grouping_fields'].length - 1] : this.editedItem['grouping_fields']
        Object.assign(dateItem, this.dateField)
        this.dialogDateOptions = false
        this.toggleFieldSelect = true
      },
      closeFieldDate () {
        // tira o ultimo item da lista selecionado, no caso a data
        if (Array.isArray(this.editedItem['grouping_fields'])) {
          this.editedItem['grouping_fields'].pop()
          this.beforeLengthSelectedFields = this.editedItem['grouping_fields'].length
        } else {
          this.editedItem['grouping_fields'] = this.defaultEditedItem['grouping_fields']
        }
        this.dialogDateOptions = false
        this.toggleFieldSelect = true
        this.$refs.form.resetValidation()
      },
      // como os cards são armazenados em um campo da tabela dashboard, usa o type para definir se será edição(edit) adição(add) ou deleção(del)
      // Caso o type seja vazio deve apenas editar normal, no caso de resize ou de movimentar o card
      changeItem (type) {
        // usado items e itemsBDMobile como variaveis auxiliares que fazem as alterações pra so depois de salvar a dashboard passar para as variáveis verdadeiras, evitando que tente buscar os valores dos charts antes de ter salvo a propria criação, e tbm caso de erro não altera as principais
        let items = JSON.parse(JSON.stringify(this.items))
        let itemsBDMobile = JSON.parse(JSON.stringify(this.itemsBDMobile))
        // this.$store.commit('loader/change_dialog', true)
        if (type === 'add') {
          this.loading = true
          let maxCardId = items.reduce((a, b) => a > b.i ? a : b.i, 0)
          this.editedItem['i'] = maxCardId + 1
          items.push(this.editedItem)
          itemsBDMobile.push(JSON.parse(JSON.stringify(this.editedItem)))
        } else if (type === 'del') {
          this.$store.commit('loader/change_dialog', true)
          items = items.filter((item) => { return item['i'] !== this.editedItem['i'] })
          // caso seja tamanho mobile, usa a variavel itemsBDMobile, para salvar tudo com as posições normais
          itemsBDMobile = itemsBDMobile.filter((item) => { return item['i'] !== this.editedItem['i'] })
        } else if (type === 'edit') {
          let item = items.find((item) => { return item['i'] === this.editedItem['i'] })
          let itemBDMobile = itemsBDMobile.find((item) => { return item['i'] === this.editedItem['i'] })
          // Tira as posições x, y, w, h para não subistiuir no banco e permanecer as posições normais
          delete this.editedItem['x']
          delete this.editedItem['y']
          delete this.editedItem['w']
          delete this.editedItem['h']
          Object.assign(itemBDMobile, this.editedItem)
          Object.assign(item, this.editedItem)
        }
        // Caso seja mobile, pega os valores do itemsBDMobile os quais possui as posições normais dos graficos, não substituindo pelas posições no mobile que são apenas visuais
        let saveItem = this.$vuetify.breakpoint.smAndDown ? itemsBDMobile : items
        // insere um item
        this.$http.put(`api/${this.entity}/${this.dashboard['id']}`, {'id_text': JSON.stringify(saveItem)}).then(
          (res) => {
            this.items = items
            this.itemsBDMobile = itemsBDMobile
            if (type === 'edit') {
              let ref = 'chart' + this.editedItem['i']
              this.$refs[ref][0].reloadItems()
            }
            // Manda o socket com o itemsBDMobile, pois o items pode estar com as posições diferentes no mobile
            this.$socket.emit('generalEvent', {
              data: {'isMobile': this.$vuetify.breakpoint.smAndDown},
              responseEvent: 'socketReloadDashboard',
              room: 'dashboard_' + this.dashboard['id']
            })
            // this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', { text: (this.translate('table.' + this.entity + '.title')[0]) + ' alterada com sucesso!', color: 'success', dialog: true })
            this.dialogConfirm = false
            this.dialogCreate = false
            this.dialogFilters = false
            this.loading = false
            this.$store.commit('loader/change_dialog', false)
          },
          err => {
            console.log(err)
            this.dialogCreate = false
            this.loading = false
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', { text: 'Não foi possível incluir o registro' + (this.translate('table.' + this.entity + '.title')[0]) + ', reporte o erro.', color: 'error', dialog: true })
          })
      },
      processSave () {
        if (this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        this.$store.commit('loader/change_dialog', true)
        // caso tenha o i significa que está em ediçaõ
        this.changeItem(this.editedItem['i'] > 0 ? 'edit' : 'add')
      },
      createItem () {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultEditedItem))
        this.mountFieldItems()
        this.dialogCreate = true
        this.$refs.form.resetValidation()
      },
      editItem (cardId) {
        this.mountFieldItems()
        let item = this.items.find((item) => { return item['i'] === cardId })
        this.editedItem = JSON.parse(JSON.stringify(item))
        this.dialogCreate = true
      },
      filtersItem (cardId) {
        // this.mountFieldItems()
        let item = this.items.find((item) => { return item['i'] === cardId })
        this.editedItem = JSON.parse(JSON.stringify(item))
        this.dialogFilters = true
      },
      closeFilters () {
        this.dialogFilters = false
        this.editedItem = JSON.parse(JSON.stringify(this.defaultEditedItem))
      },
      deleteItem (cardId) {
        this.editedItem['i'] = cardId
        this.dialogConfirm = true
      },
      closeDialogCreate () {
        this.dialogCreate = false
        this.editedItem = JSON.parse(JSON.stringify(this.defaultEditedItem))
      },
      changeCardtype (val) {
        let defaultEditedItem = JSON.parse(JSON.stringify(this.defaultEditedItem))
        // caso seja tabela o grouping_fields e o fields devem ser array
        defaultEditedItem['fields'] = val === 1 ? [] : null
        defaultEditedItem['grouping_fields'] = val === 1 ? [] : null
        defaultEditedItem['card_type'] = this.editedItem['card_type']
        defaultEditedItem['id_text'] = this.editedItem['id_text']
        defaultEditedItem['color'] = this.editedItem['color']
        // Recebe o i para quando tiver editando
        defaultEditedItem['i'] = this.editedItem['i']
        // inclui o titulo e a cor no final para não zerar eles
        this.editedItem = defaultEditedItem
        this.$refs.form.resetValidation()
      },
      mountFieldItems () {
        this.loadingFields = true
        this.fieldItems = []
        // adicionas o header de campos
        this.fieldItems.push({header: 'Campos', type: 'custom'})
        // insere todos os campos da tarefa
        Array.prototype.push.apply(this.fieldItems, this.translate('value.dashboard_fields_table'))
        // adicionas o header de campos personalizados
        this.fieldItems.push({header: 'Campos Personalizados', type: 'custom'})
        let selectedBoardId = this.$store.getters[`selectedBoard/id`]
        // busca todos os campos personalizados das tarefas modelos selecionadas na area de trabalho
        this.$http.get(`api/get_fields_dashboard/${selectedBoardId}`).then((res) => {
          this.fieldsTemplate = res.body
          // Adicionas os campos personalizados na lista de campos a serem selecioandos para dashboard
          // Coloca o cf pois se for so o numero da problema ao mostrar os dados
          this.fieldsTemplate.map((customField) => { this.fieldItems.push({value: 'cf' + customField['id'], custom_field_id: customField['id'], text: customField['title'], category: 'custom_field', aggregate_function: ['value', 'number'].includes(customField['type']) ? 'SUM' : '', type: customField['type']}) })
          this.loadingFields = false
        }, err => {
          console.log(err)
          this.loadingFields = false
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível buscar os campos personalizados, reporte o erro.', color: 'error', dialog: true})
        })
      },
      getFieldItem (item, size = null) {
        let result = ''
        size = size === null ? item['text'].length : size
        if (item['category'] === 'custom_field') {
          let values = this.fieldsTemplate.find((val) => val['id'] === item['custom_field_id'])
          // caso seja um campo d euma tarefa modelo. Pega o nome da tarefa modelo e corta proporcional ao nome do campo para ficar certinho
          if (values['tasktemplate']) {
            result = `${values['tasktemplate']['identifier']}-${values['tasktemplate']['id_text']}`
            result = result.length > size ? result.slice(0, size + 3) + '...' : result
          }
        }
        //  else if (item['category'] === 'datetime' && item['date_type']) {
        //   let dateType = this.translate('value.dashboard_date_type').find((val) => val['value'] === item['date_type'])
        //   if (dateType) result = dateType['text']
        // }
        return result
      },
      dashReload () {
        location.reload()
      }
    },
    destroyed () {
      clearInterval(this.intervalReload)
      this.$socket.emit('leaveRoom', {room: 'dashboard_' + this.dashboard['id']})
    }
    // computed: {
    //   filterTypes () {}
    // },
    // destroyed () {
    //   clearInterval(this.setDashboardInterval)
    // }
  }
</script>
<style>
.layoutJSON {
    background: #ddd;
    border: 1px solid black;
    margin-top: 10px;
    padding: 10px;
}
.columns {
    -moz-columns: 120px;
    -webkit-columns: 120px;
    columns: 120px;
}
/*************************************/
.vue-grid-layout {
    background: #eee;
}
.vue-grid-item:not(.vue-grid-placeholder) {
    background: rgb(255, 255, 255);
    border-radius: 15px;
}
.vue-grid-item .resizing {
    opacity: 0.9;
}
.vue-grid-item .static {
    background: #cce;
}
.add-chart {
  height: 100px;
  width: 300px;
  border-radius: 15px;
}
/* .vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
} */
.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}
.vue-grid-item .minMax {
    font-size: 12px;
}
.vue-grid-item .add {
    cursor: pointer;
}
/* .vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
} */

.vue-resizable-handle {
  background-position: 60% 60% !important;
  background-size: 8px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboardCustom/DashboardCustom.vue